import {FlaggedMeter, FlaggedMeterEntity} from "../../../model/flagged-meter";
import {getUseQueryResultData} from "../../../util/selector-util";
import {createSelector} from "@reduxjs/toolkit";

export const flaggedMetersSelector = () => createSelector(
  [getUseQueryResultData<FlaggedMeter[]>],
  (data) => {
    return selectAndTransform(data ?? []);
  }
);

export const flaggedMeterSelector = () => createSelector(
  [getUseQueryResultData<FlaggedMeter>],
  (data) => {
    return data ? transform(data) : undefined;
  }
);

export const transform = (value: FlaggedMeter): FlaggedMeterEntity => {
  return FlaggedMeterEntity.from(value)
}

export const selectAndTransform = (values?: FlaggedMeter[]): FlaggedMeterEntity[] => {
  return (values ?? []).map(transform);
};
